import styled from "styled-components";
import { useAppSelector } from "store/hooks";
import themeProps from "theme/themes";
import { IMessage } from "common/interfaces/IMessage";

interface MessageProps {
  message: IMessage;
}

const WrapperBasic = styled.div`
  width: 55%;
  max-width: 500px;
  border-radius: 20px;
  padding: 12px 15px;
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Wrapper = styled(WrapperBasic)(({ sender }: { sender: boolean }) => ({
  backgroundColor: sender ? "#7D02FA" : "#FFF",
  color: sender ? "#fff" : "#000",
  border: sender ? "none" : "1px solid #B3B3B3",
  marginLeft: sender ? "auto" : "0px",
}));

const Sender = styled.p`
  font-size: 1.3rem;
  margin-bottom: 5px;
  color: ${(props: themeProps) => props.theme.main.primary};
`;
const Text = styled.p`
  font-size: 1.3rem;
`;
// const Time = styled.p`
//   align-self: flex-end;
// `;

const Message = ({ message }: MessageProps) => {
  const userId = useAppSelector((state) => state.user.auth?.userId);

  return (
    <Wrapper sender={message?.sender?._id === userId}>
      {message?.sender?._id !== userId && (
        <Sender>{message?.sender?.name}</Sender>
      )}
      <Text>{message?.content}</Text>
    </Wrapper>
  );
};

export default Message;
